import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Trash2 } from 'lucide-react';

const DeleteCircleDialog = ({ open, onOpenChange, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button variant="outline" size="sm" className="text-destructive hover:text-destructive" data-testid="delete-circle-btn">
        <Trash2 className="w-4 h-4 mr-2" /> Delete
      </Button>
    </DialogTrigger>
    <DialogContent className="surface-card">
      <DialogHeader>
        <DialogTitle>Delete Circle</DialogTitle>
        <DialogDescription>Are you sure you want to delete this circle? This will remove all members, posts, tasks, and data. This action cannot be undone.</DialogDescription>
      </DialogHeader>
      <div className="flex gap-3 mt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">Cancel</Button>
        <Button onClick={onDelete} className="flex-1 bg-destructive hover:bg-destructive/90 text-destructive-foreground" data-testid="confirm-delete-circle-btn">Delete Circle</Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default DeleteCircleDialog;
